// UTA publishes one faculty profile page per NetID; the database stores that NetID as UTA_Faculty.uta_username.
const UTA_PROFILE_BASE = "https://www.uta.edu/academics/faculty/profile?username=";

export const utaProfileUrl = (username) => {
  const id = typeof username === "string" ? username.trim() : "";
  return id ? `${UTA_PROFILE_BASE}${encodeURIComponent(id)}` : null;
};
